// extracted by mini-css-extract-plugin
export var standaloneTable = "_ge-0";
export var standaloneTableWithBodyFill = "_ge-1";
export var withExtraHeader = "_ge-2";